import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { HttpClient } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
import { EndpointService } from '@app/core';
import { CategoryHelps, Helps } from '@app/shared/models/helps.model';
import { result } from 'lodash';

@Injectable()
export class HelpsDataService {
  constructor(private http: HttpClient, private toastr: ToastrService, private api: EndpointService) { }

  /**
   * Consulta las ayudas del sistema
   *
   * @returns {Observable<Helps[]>}
   * @memberof HelpsDataService
   */
  gethelps(idCategoria:number): Observable<Helps[]> {
    return new Observable(obs => {
      this.http.skipErrorHandler()
      .get<Helps[]>(this.api.get('helps',[idCategoria])).subscribe(
        response => {
          obs.next(response);
        },
        err => {
          obs.error(err);
          if (err.status !== 401 && err.status !== 403) {
            this.toastr.error('Lo sentimos ha ocurrido un error', 'Fallo de operación');
          }
        }
      );
    });
  }

  /**
   * Consulta las ayudas del sistema
   *
   * @returns {Observable<CategoryHelps[]>}
   * @memberof HelpsDataService
   */
  getCategoryHelp(): Observable<CategoryHelps[]> {
    return new Observable(obs => {
      this.http.skipErrorHandler()
      .get<CategoryHelps[]>(this.api.get('categoryHelps')).subscribe(
        response => {
          obs.next(response);
        },
        err => {
          obs.error(err);
          if (err.status !== 401 && err.status !== 403) {
            this.toastr.error('Lo sentimos ha ocurrido un error', 'Fallo de operación');
          }
        }
      );
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/helps/shared/helps-data.service.ts